import {
    FETCH_CONSOLIDATED_STEP_GOAL,
    FETCH_CONSOLIDATED_STEP_GOAL_FETCHING,
    FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS,
    FETCH_CONSOLIDATED_STEP_GOAL_FAIL,
    UPDATE_CONSOLIDATED_STEP_GOAL,
    UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS,
    UPDATE_CONSOLIDATED_STEP_GOAL_FAIL,
    RESET_CONSOLIDATED_STEP_GOAL_UPDATE
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    consolidatedStepsGoalFetching: false,
    consolidatedStepsGoalFetchFail: false,
    consolidatedStepsGoalUpdateSucceed: false,
    consolidatedStepsGoalUpdateFail: false
};

// ======= Fetching Handlers =======
const fetchConsolidatedStepsGoalFetching = (state, action) => {
    return {
        ...state,
        consolidatedStepsGoalFetching: true,
        consolidatedStepsGoalFetchFail: false
    };
};

const fetchConsolidatedStepsGoalSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.calendarDate]: action.data
        },
        consolidatedStepsGoalFetching: false,
        consolidatedStepsGoalFetchFail: false
    };
};

const fetchConsolidatedStepsGoalFail = (state, action) => {
    return {
        ...state,
        consolidatedStepsGoalFetching: false,
        consolidatedStepsGoalFetchFail: true
    };
};

// ======= Updating Handlers =======
const updateConsolidatedStepsGoalSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.calendarDate]: action.data
        },
        consolidatedStepsGoalUpdateSucceed: true,
        consolidatedStepsGoalUpdateFail: false
    };
};

const updateConsolidatedStepsGoalFail = (state, action) => {
    return {
        ...state,
        consolidatedStepsGoalUpdateSucceed: false,
        consolidatedStepsGoalUpdateFail: true
    };
};

const resetConsolidatedStepsGoalUpdateFlags = (state) => {
    return {
        ...state,
        consolidatedStepsGoalUpdateSucceed: false,
        consolidatedStepsGoalUpdateFail: false
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_CONSOLIDATED_STEP_GOAL_FETCHING]: fetchConsolidatedStepsGoalFetching,
    [FETCH_CONSOLIDATED_STEP_GOAL_SUCCESS]: fetchConsolidatedStepsGoalSuccess,
    [FETCH_CONSOLIDATED_STEP_GOAL_FAIL]: fetchConsolidatedStepsGoalFail,
    [UPDATE_CONSOLIDATED_STEP_GOAL_SUCCESS]: updateConsolidatedStepsGoalSuccess,
    [UPDATE_CONSOLIDATED_STEP_GOAL_FAIL]: updateConsolidatedStepsGoalFail,
    [RESET_CONSOLIDATED_STEP_GOAL_UPDATE]: resetConsolidatedStepsGoalUpdateFlags
};

// ======= Default Action =======
export default function consolidatedStepsGoal(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchConsolidatedStepsGoal(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_CONSOLIDATED_STEP_GOAL,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 2000
        }
    };
}

export function updateConsolidatedStepsGoal(displayName, calendarDate, newGoal) {
    return {
        type: UPDATE_CONSOLIDATED_STEP_GOAL,
        displayName: displayName,
        calendarDate: calendarDate,
        newGoal: newGoal
    };
}

export function resetConsolidatedStepsGoalUpdate() {
    return {
        type: RESET_CONSOLIDATED_STEP_GOAL_UPDATE
    };
}

// ======= Selectors =======
export const getConsolidatedStepsGoal = (state, date) => {
    if (date) {
        return state.consolidatedStepsGoal?.data?.[date] ? state.consolidatedStepsGoal?.data?.[date] : null;
    } else {
        return state.consolidatedStepsGoal?.data ? state.consolidatedStepsGoal?.data : null;
    }
};

export const isConsolidatedStepsGoalFetching = (state) => {
    return state.consolidatedStepsGoal.consolidatedStepsGoalFetching;
};

export const didConsolidatedStepsGoalFetchFail = (state) => {
    return state.consolidatedStepsGoal.consolidatedStepsGoalFetchFail;
};

export const didConsolidatedStepsGoalUpdateSucceed = (state) => {
    return state.consolidatedStepsGoal.consolidatedStepsGoalUpdateSucceed;
};

export const didConsolidatedStepsGoalUpdateFail = (state) => {
    return state.consolidatedStepsGoal.consolidatedStepsGoalUpdateFail;
};
